import { SystemVersionEntry } from 'rio-models';

export interface SystemState {
  versions: SystemVersionEntry[];
}
export interface SystemVersionsBackendResponse {
  version: string;
  component_versions: SystemVersionEntry[];
}

export enum HelpMenuItemId {
  api = 'api',
  app = 'app',
}

export interface LinkLanguage {
  en: string;
  de: string;
}

export const LabelItem = {
  [HelpMenuItemId.api]: 'HelpMenu.API Documentation',
  [HelpMenuItemId.app]: 'HelpMenu.Manual',
} as const;

export interface HelpMenuItem {
  id: HelpMenuItemId;
  link: LinkLanguage;
  label: string;
}

export type UserDocsUrls = {
  [key in HelpMenuItemId]: LinkLanguage;
};
